<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :$_em-custom-vuex-mixin_entity="entityState"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author liang gang qiang
    // Date 2023-09-28 09:53:17

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "sithMomMainProjectPlanScheduledRecordEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            entityState() {
                return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
            }
        }
    };
</script>